import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const resourceGovernanceSettingSortOptions: OptionsDictionary = {
  'siteName': SortOptions.siteName,
};
